import React, { useEffect, useState } from "react";
import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/20/solid";
import {
  CursorArrowRaysIcon,
  EnvelopeOpenIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

import i18n from "@/i18n";
import CustomerService from "@/services/CustomerService";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Example() {
  const { t } = useTranslation();
  const [stats, setStats] = useState([
    {
      id: 1,
      name: "loading",
      stat: "",
      icon: UsersIcon,
      change: "",
      changeType: "increase vs previous",
    },
    {
      id: 2,
      name: "loading",
      stat: "",
      icon: EnvelopeOpenIcon,
      change: "",
      changeType: "increase vs previous",
    },
    {
      id: 3,
      name: "loading",
      stat: "",
      icon: CursorArrowRaysIcon,
      change: "",
      changeType: "increase vs previous",
    },
  ]);

  useEffect(() => {
    async function fetchStats() {
      const statsResponse = await CustomerService.getCustomerStats();
      if (statsResponse.error) {
        console.error("Failed to load stats:", statsResponse.error);
        Swal.fire({
          title: i18n.t("notifications.errorTitle"),
          text: statsResponse.error,
          icon: "error",
        });
        return;
      }

      const data = statsResponse.data || {};
      const totalCustomers = data.totalCustomers ?? 0;
      const currentMonth = data.currentMonth || { count: 0, delta: 0 };
      const previousMonth = data.previousMonth || { count: 0, delta: 0 };

      setStats([
        {
          id: 1,
          name: "totalCustomers",
          stat: totalCustomers,
          icon: UsersIcon,
        },
        {
          id: 2,
          name: "customersThisMonth",
          stat: currentMonth.count ?? 0,
          icon: UsersIcon,
          change: `${currentMonth.delta ?? 0} customers`,
          changeType: "decrease",
        },
        {
          id: 3,
          name: "customersLastMonth",
          stat: previousMonth.count ?? 0,
          icon: UsersIcon,
          change: `${previousMonth.delta ?? 0} customers`,
          changeType: "decrease",
        },
      ]);
    }
    fetchStats();
  }, []);

  return (
    <div className="mb-5">
      <dl className="mt-2 mb-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((item) => (
          <div
            key={item.id}
            className="relative overflow-hidden rounded-lg bg-white px-4 pt-4 pb-5 shadow-sm sm:px-9 sm:pt-4"
          >
            <dt className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="absolute rounded-md bg-indigo-500 p-3 mt-1">
                  <item.icon aria-hidden="true" className="size-3 text-white" />
                </div>
                <p className="ml-16 truncate text-md font-medium text-gray-500">
                  {t(`customers.list.stats.${item.name}`)}
                </p>
              </div>
              <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
            </dt>
            <dd className="ml-16 flex items-baseline pb-6 sm:pb-3 sm:pt-1">
              {/* {item.changeType ? (
                <p
                  className={classNames(
                    item.changeType === "increase"
                      ? "text-green-600"
                      : "text-red-600",
                    "ml-2 flex items-baseline text-sm font-semibold"
                  )}
                >
                  {item.changeType === "increase" ? (
                    <ArrowUpIcon
                      aria-hidden="true"
                      className="size-5 shrink-0 self-center text-green-500"
                    />
                  ) : (
                    <ArrowDownIcon
                      aria-hidden="true"
                      className="size-5 shrink-0 self-center text-red-500"
                    />
                  )}

                  <span className="sr-only">
                    {" "}
                    {item.changeType === "increase"
                      ? "Increased"
                      : "Decreased"}{" "}
                    by{" "}
                  </span>
                  {item.change}
                </p>
              ) : null} */}
              <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-2 sm:px-6">
                <div className="text-sm"></div>
              </div>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
